(() => {
  const regions = document.querySelectorAll('.zs-pdp-parity__purchase, .zs-cart-item__buy, .zs-cart-summary');
  if (!regions.length || !('IntersectionObserver' in window)) return;
  const visible = new Set();
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    document.documentElement.classList.toggle('zs-mobile-purchase-visible', visible.size > 0);
  });
  regions.forEach(region => observer.observe(region));
})();
